<template>
  <ContentWrapperControl
    no_bottom
    full_width
    :centered="false"
    is_grid
    class="h-screen overflow-hidden flex flex-col"
    :style="{ backgroundColor: getTheme }"
  >
    <ModalControl
      @closed="closeNotice"
      :dismiss="false"
      :show="showNotice"
      :title="lang('lbl_0000360')"
      theme="info"
    >
      <div>
        <img
          src="@/assets/icons/papsi_info_blue.svg"
          class="block mx-auto mt-2 mb-3 h-modal-icon w-modal-icon"
        />

        <div class="mb-3 text-center">{{ getModalMessage }}</div>

        <div
          v-if="getCurrentNotice === 'bod'"
          class="flex flex-col items-center"
        >
          <div
            v-text="lang('lbl_0000362')"
            class="inline-block text-center py-2 px-3 mb-3 bg-grey-lighter rounded-full mx-auto"
          ></div>
          <div
            v-text="lang('lbl_0000363')"
            class="inline-block text-center py-2 px-3 mb-3 bg-grey-lighter rounded-full mx-auto"
          ></div>
          <div
            v-text="lang('lbl_0000364')"
            class="inline-block text-center py-2 px-3 mb-6 bg-grey-lighter rounded-full mx-auto"
          ></div>
        </div>

        <!-- <div
          v-else-if="getCurrentNotice === 'audit'"
          class="flex flex-col items-center"
        >
          <div
            v-text="lang('lbl_0000366')"
            class="inline-block text-center py-2 px-3 mb-6 bg-grey-lighter rounded-full mx-auto"
          ></div>
        </div> -->

        <div
          v-else-if="getCurrentNotice === 'elecom'"
          class="flex flex-col items-center"
        >
          <div
            v-text="lang('lbl_0000368')"
            class="inline-block text-center py-2 px-3 mb-6 bg-grey-lighter rounded-full mx-auto"
          ></div>
        </div>

        <ButtonControl theme="info" @click="closeNotice">
          {{ lang("lbl_0000349") }}
        </ButtonControl>
      </div>
    </ModalControl>

    <ModalControl
      @closed="show_limit = false"
      :dismiss="false"
      :show="show_limit"
      :title="lang('lbl_0000369')"
      theme="info"
    >
      <div>
        <img
          src="@/assets/icons/papsi_info_blue.svg"
          class="block mx-auto mt-2 mb-3 h-modal-icon w-modal-icon"
        />

        <div class="mb-6 text-center">
          <template
            v-if="getActiveCategory === 'bod' && typeof show_limit === 'string'"
          >
            {{ lang("lbl_0000376") }}
            <strong>
              {{
                show_limit === "officers"
                  ? lang("lbl_0000379")
                  : show_limit === "enlisted"
                  ? lang("lbl_0000380")
                  : lang("lbl_0000381")
              }}
            </strong>
            {{ lang("lbl_0000377") }}. {{ lang("lbl_0000378") }}
          </template>
          <template v-else>
            {{ lang("lbl_0000370") }}
          </template>
        </div>
        <ButtonControl theme="info" @click="show_limit = false">
          {{ lang("lbl_0000349") }}
        </ButtonControl>
      </div>
    </ModalControl>

    <ModalControl
      @closed="show_confirm = false"
      :dismiss="true"
      :show="show_confirm"
      :title="lang('lbl_0000373')"
    >
      <div class="confirm-modal-body">
        <div class="mt-3 mb-6 text-sm text-center">
          {{ lang("lbl_0000374") }}
        </div>

        <div v-if="getSelectedBOD.officers.length" class="summary-group">
          <div class="summary-group-header flex justify-between items-center">
            <div>
              <div class="summary-group-title">Board of Directors</div>
              <div class="summary-subtitle">Officer Category ({{ this.getSelectedBOD.officers.length }})</div>
            </div>
            <button
              @click="startEditingCategory('bod', 'modal')"
              class="edit-btn"
            >
              <img
                src="@/assets/icons/papsi_edit_white.svg"
                alt="Edit"
                class="w-5 h-5"
              />
            </button>
          </div>
          <div class="summary-group-body">
            <div
              v-for="c in getSelectedBOD.officers"
              :key="c.code"
              class="summary-item"
            >
              {{ c.name }}
            </div>
          </div>
        </div>

        <div v-if="getSelectedBOD.enlisted.length" class="summary-group">
          <div class="summary-group-header flex justify-between items-center">
            <div>
              <div class="summary-group-title">Board of Directors</div>
              <div class="summary-subtitle">Enlisted Personnel Category ({{ this.getSelectedBOD.enlisted.length }})</div>
            </div>
            <button
              @click="startEditingCategory('bod', 'modal')"
              class="edit-btn"
            >
              <img
                src="@/assets/icons/papsi_edit_white.svg"
                alt="Edit"
                class="w-5 h-5"
              />
            </button>
          </div>
          <div class="summary-group-body">
            <div
              v-for="c in getSelectedBOD.enlisted"
              :key="c.code"
              class="summary-item"
            >
              {{ c.name }}
            </div>
          </div>
        </div>

        <div v-if="getSelectedBOD.civilians.length" class="summary-group">
          <div class="summary-group-header flex justify-between items-center">
            <div>
              <div class="summary-group-title">Board of Directors</div>
              <div class="summary-subtitle">Civilian Category ({{ this.getSelectedBOD.civilians.length }})</div>
            </div>
            <button
              @click="startEditingCategory('bod', 'modal')"
              class="edit-btn"
            >
              <img
                src="@/assets/icons/papsi_edit_white.svg"
                alt="Edit"
                class="w-5 h-5"
              />
            </button>
          </div>
          <div class="summary-group-body">
            <div
              v-for="c in getSelectedBOD.civilians"
              :key="c.code"
              class="summary-item"
            >
              {{ c.name }}
            </div>
          </div>
        </div>

        <div v-if="getSelectedAudit.length" class="summary-group">
          <div
            class="summary-group-header-audit flex justify-between items-center"
          >
            <div>
              <div class="summary-group-title">Audit Committee</div>
              <!-- <div class="summary-subtitle">At Large</div> -->
            </div>
            <button
              @click="startEditingCategory('audit', 'modal')"
              class="edit-btn"
            >
              <img
                src="@/assets/icons/papsi_edit_white.svg"
                alt="Edit"
                class="w-5 h-5"
              />
            </button>
          </div>
          <div class="summary-group-body">
            <div
              v-for="c in getSelectedAudit"
              :key="c.code"
              class="summary-item"
            >
              {{ c.name }}
            </div>
          </div>
        </div>

        <div v-if="getSelectedElecom.civilians.length" class="summary-group">
          <div
            class="summary-group-header-elecom flex justify-between items-center"
          >
            <div>
              <div class="summary-group-title">Election Committee</div>
              <div class="summary-subtitle">Civilian Category ({{ this.getSelectedElecom.civilians.length }})</div>
            </div>
            <button
              @click="startEditingCategory('elecom', 'modal')"
              class="edit-btn"
            >
              <img
                src="@/assets/icons/papsi_edit_white.svg"
                alt="Edit"
                class="w-5 h-5"
              />
            </button>
          </div>
          <div class="summary-group-body">
            <div
              v-for="c in getSelectedElecom.civilians"
              :key="c.code"
              class="summary-item"
            >
              {{ c.name }}
            </div>
          </div>
        </div>

        <ButtonControl class="w-full mt-2" @click="submitVotes">
          {{ this.lang("lbl_0000190") }}
        </ButtonControl>
      </div>
    </ModalControl>

    <div
      class="flex flex-row mt-2 justify-between items-center w-full text-white text-sm font-medium p-4"
    >
      <button
        class="rounded-lg p-1 flex items-center justify-center shadow-md navigation"
        @click="handleBack"
      >
        <img
          src="@/assets/icons/papsi_arrow_back_alt.svg"
          alt="Back"
          class="w-5 h-5"
        />
      </button>

      <img
        :src="getImage('ga/', 'papsi_logo.png')"
        alt="PAPSI Logo"
        class="h-6 w-auto object-contain"
      />

      <button
        class="rounded-lg p-1 flex items-center justify-center shadow-md navigation"
        @click="show_summary = !show_summary"
      >
        <img
          src="@/assets/icons/papsi_ballot.svg"
          alt="Summary"
          class="w-5 h-5"
        />
      </button>
    </div>

    <span class="font-bold text-secondary text-xl mt-3 mb-3 text-center block">
      {{ this.lang(getCategoryTitle) }}
    </span>

    <div class="status-chips">
      <template v-if="getActiveCategory === 'bod'">
        <div
          class="chip"
          :style="{ opacity: getSelectedCount.officers === 0 ? 0.5 : 1 }"
        >
          {{ getSelectedCount.officers }}/3 - {{ lang("lbl_0000174") }}
        </div>
        <div
          class="chip"
          :style="{ opacity: getSelectedCount.enlisted === 0 ? 0.5 : 1 }"
        >
          {{ getSelectedCount.enlisted }}/3 - {{ lang("lbl_0000175") }}
        </div>
        <div
          class="chip"
          :style="{ opacity: getSelectedCount.civilians === 0 ? 0.5 : 1 }"
        >
          {{ getSelectedCount.civilians }}/2 - {{ lang("lbl_0000350") }}
        </div>
      </template>

      <template v-else-if="getActiveCategory === 'audit'">
        <div class="chip">{{ getSelectedCount.total }}/2</div>
      </template>

      <template v-else-if="getActiveCategory === 'elecom'">
        <div
          class="chip"
          :style="{ opacity: getSelectedCount.civilians === 0 ? 0.5 : 1 }"
        >
          {{ getSelectedCount.civilians }}/1 - Civilian
        </div>
      </template>
    </div>

    <div
      class="bg-white rounded-t-3xl w-full p-4 flex-grow overflow-y-auto min-h-0 rounded-t-lg"
      style="padding-bottom: 100px"
    >
      <div
        style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 15px"
      >
        <div
          v-for="candidate in getActiveCandidates"
          :key="candidate.code"
          @click="toggleSelect(candidate.code)"
          :class="{ selected: getSelectedCandidates.includes(candidate.code) }"
          :style="
            getSelectedCandidates.includes(candidate.code)
              ? { backgroundColor: getSelectedTheme }
              : {}
          "
          class="candidate-card col-span-1 relative border border-green-600 rounded-xl shadow-sm flex flex-col items-center justify-center bg-white w-full"
        >
          <img
            v-if="getSelectedCandidates.includes(candidate.code)"
            :src="getCheckIcon"
            class="check-icon"
            alt="Selected"
          />
          <img
            :src="candidate.photo || getImage('ga/', 'papsi_placeholder.jpg')"
            @error="getPlaceholder"
            class="rounded-lg"
            alt="Candidate Photo"
          />
          <span
            class="font-bold uppercase text-center text-sm leading-tight mt-2 h-16 flex items-center justify-center"
          >
            {{ candidate.name }}
          </span>
          <span class="text-[10px] text-xs mt-1 mb-3 text-center">
            {{ candidate.type }}
          </span>
        </div>
      </div>
    </div>

    <div class="bottom-bar">
      <div class="progress-container">
        <div
          class="progress-fill"
          :style="{ width: getProgressPercent + '%' }"
        ></div>
      </div>

      <div class="bottom-inner">
        <div class="votes-text">
          <div class="label mb-1">Selected Votes</div>
          <div class="count">{{ getTotalSelected }} of {{ getTotalLimit }}</div>
        </div>
        <div>
          <ButtonControl
            :outline="true"
            :full_width="false"
            class="w-28 mr-3"
            @click="$store.state.ga.selected_candidates[getActiveCategory] = []"
            :theme="getButtonTheme"
          >
            {{ this.lang("lbl_0000017") }}
          </ButtonControl>

          <ButtonControl
            :full_width="false"
            class="w-28"
            :disabled="getTotalSelected < getTotalLimit"
            @click="handleProceed"
            :theme="getButtonTheme"
          >
            {{ this.lang("lbl_0000015") }}
          </ButtonControl>
        </div>
      </div>
    </div>

    <div v-show="show_summary" class="summary-sidebar">
      <button class="summary-collapse-btn" @click="show_summary = false">
        <img
          src="@/assets/icons/papsi_summary_collapse.svg"
          alt="Collapse"
          class="w-5 h-5"
        />
      </button>

      <div class="summary-scroll">
        <div class="summary-header">My Current Votes</div>

        <div v-if="getSelectedBOD.officers.length" class="summary-group">
          <div class="summary-group-header flex justify-between items-center">
            <div>
              <div class="summary-group-title">Board of Directors</div>
              <div class="summary-subtitle">Officer Category</div>
            </div>
            <button
              @click="startEditingCategory('bod', 'sidebar')"
              class="edit-btn"
            >
              <img
                src="@/assets/icons/papsi_edit_white.svg"
                alt="Edit"
                class="w-5 h-5"
              />
            </button>
          </div>
          <div class="summary-group-body">
            <div
              v-for="c in getSelectedBOD.officers"
              :key="c.code"
              class="summary-item"
            >
              {{ c.name }}
            </div>
          </div>
        </div>

        <div v-if="getSelectedBOD.enlisted.length" class="summary-group">
          <div class="summary-group-header flex justify-between items-center">
            <div>
              <div class="summary-group-title">Board of Directors</div>
              <div class="summary-subtitle">Enlisted Personnel Category</div>
            </div>
            <button
              @click="startEditingCategory('bod', 'sidebar')"
              class="edit-btn"
            >
              <img
                src="@/assets/icons/papsi_edit_white.svg"
                alt="Edit"
                class="w-5 h-5"
              />
            </button>
          </div>
          <div class="summary-group-body">
            <div
              v-for="c in getSelectedBOD.enlisted"
              :key="c.code"
              class="summary-item"
            >
              {{ c.name }}
            </div>
          </div>
        </div>

        <div v-if="getSelectedBOD.civilians.length" class="summary-group">
          <div class="summary-group-header flex justify-between items-center">
            <div>
              <div class="summary-group-title">Board of Directors</div>
              <div class="summary-subtitle">Civilian Category</div>
            </div>
            <button
              @click="startEditingCategory('bod', 'sidebar')"
              class="edit-btn"
            >
              <img
                src="@/assets/icons/papsi_edit_white.svg"
                alt="Edit"
                class="w-5 h-5"
              />
            </button>
          </div>
          <div class="summary-group-body">
            <div
              v-for="c in getSelectedBOD.civilians"
              :key="c.code"
              class="summary-item"
            >
              {{ c.name }}
            </div>
          </div>
        </div>

        <div v-if="getSelectedAudit.length" class="summary-group">
          <div
            class="summary-group-header-audit flex justify-between items-center"
          >
            <div>
              <div class="summary-group-title">Audit Committee</div>
              <!-- <div class="summary-subtitle">At Large</div> -->
            </div>
            <button
              @click="startEditingCategory('audit', 'sidebar')"
              class="edit-btn"
            >
              <img
                src="@/assets/icons/papsi_edit_white.svg"
                alt="Edit"
                class="w-5 h-5"
              />
            </button>
          </div>
          <div class="summary-group-body">
            <div
              v-for="c in getSelectedAudit"
              :key="c.code"
              class="summary-item"
            >
              {{ c.name }}
            </div>
          </div>
        </div>

        <div v-if="getSelectedElecom.civilians.length" class="summary-group">
          <div
            class="summary-group-header-elecom flex justify-between items-center"
          >
            <div>
              <div class="summary-group-title">Election Committee</div>
              <div class="summary-subtitle">Civilian Category</div>
            </div>
            <button
              @click="startEditingCategory('elecom', 'sidebar')"
              class="edit-btn"
            >
              <img
                src="@/assets/icons/papsi_edit_white.svg"
                alt="Edit"
                class="w-5 h-5"
              />
            </button>
          </div>
          <div class="summary-group-body">
            <div
              v-for="c in getSelectedElecom.civilians"
              :key="c.code"
              class="summary-item"
            >
              {{ c.name }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </ContentWrapperControl>
</template>

<script>
import ContentWrapperControl from "@/components/controls/ContentWrapperControl.vue";
import ButtonControl from "@/components/controls/ButtonControl.vue";
import ModalControl from "@/components/controls/ModalControl.vue";
import GA from "@/services/GA";
import mixin from "@/mixin";

export default {
  mixins: [mixin],
  emits: [
    "success",
    "error",
    "alert",
    "login",
    "logout",
    "showloader",
    "hideloader",
    "showblinder",
    "hideblinder",
    "terminate",
    "checkauth",
    "nofooter",
    "shownavbar",
    "hidenavbar",
    "opensidebar",
    "closed",
    "agreed",
  ],
  components: {
    ContentWrapperControl,
    ModalControl,
    ButtonControl,
  },
  watch: {
    getActiveCategory(newCategory) {
      this.updateNotice(newCategory);
    },
  },
  data() {
    return {
      state: null,
      show_summary: false,
      show_limit: false,
      show_confirm: false,
      show_notice: {
        bod: true,
        elecom: false,
        audit: false,
      },
      election: {
        code: null,
        title: null,
        date: null,
        candidates: {
          bod: this.$store.state.ga.candidates.bod,
          voting_bod: true,
          elecom: this.$store.state.ga.candidates.elecom,
          voting_elecom: false,
          audit: this.$store.state.ga.candidates.audit,
          voting_audit: false,
        },
      },
      edit_return_category: null,
    };
  },
  mounted() {
    this.$emit("checkauth");
    this.$emit("hidenavbar");
    this.$emit("nofooter", true);
    if (
      this.$store.state.ga.code === null ||
      this.$store.state.ga.candidates.bod.length === 0
    ) {
      this.loadElection();
    } else {
      this.$emit("hideloader");
    }

    this.updateNotice(this.getActiveCategory);
  },
  computed: {
    getButtonTheme() {
      const map = {
        bod: "success",
        elecom: "elecom",
        audit: "audit",
      };
      return map[this.getActiveCategory] || "info";
    },
    getCheckIcon() {
      const map = {
        bod: require("@/assets/icons/papsi_check_circle_filled.svg"),
        elecom: require("@/assets/icons/papsi_check_elecom.svg"),
        audit: require("@/assets/icons/papsi_check_adcom.svg"),
      };
      return map[this.getActiveCategory] || map.bod;
    },
    getTheme() {
      const map = {
        bod: "#016b00",
        elecom: "#6485b8",
        audit: "#25387a",
      };

      return map[this.getActiveCategory] || map.bod;
    },
    getSelectedTheme() {
      const map = {
        bod: "#EAFFE9",
        elecom: "#E5F0FF",
        audit: "#E5F0FF",
      };
      return map[this.getActiveCategory] || map.bod;
    },
    showNotice() {
      return (
        this.show_notice.bod ||
        this.show_notice.elecom ||
        this.show_notice.audit
      );
    },
    getCurrentNotice() {
      if (this.show_notice.bod) return "bod";
      if (this.show_notice.audit) return "audit";
      if (this.show_notice.elecom) return "elecom";
      return null;
    },
    getModalMessage() {
      switch (this.getCurrentNotice) {
        case "bod":
          return this.lang("lbl_0000361");
        case "audit":
          return this.lang("lbl_0000365");
        case "elecom":
          return this.lang("lbl_0000367");
        default:
          return "";
      }
    },
    getCategoryTitle() {
      const map = {
        bod: "lbl_0000169",
        elecom: "lbl_0000173",
        audit: "lbl_0000176",
      };

      return map[this.getActiveCategory];
    },

    getActiveCategory() {
      return this.$store.state.ga.active_category;
    },

    getActiveCandidates() {
      return this.$store.state.ga.candidates[this.getActiveCategory];
    },

    getSelectedCandidates() {
      return this.$store.state.ga.selected_candidates[this.getActiveCategory];
    },
    getSelectedBOD() {
      const grouped = {
        officers: [],
        enlisted: [],
        civilians: [],
      };

      const bod_candidates = this.$store.state.ga.candidates.bod;
      const bod_selected = this.$store.state.ga.selected_candidates.bod;

      bod_candidates.forEach((candidate) => {
        if (bod_selected.includes(candidate.code)) {
          const type = candidate.type?.toLowerCase();

          if (type.includes("officer")) grouped.officers.push(candidate);
          else if (type.includes("enlisted")) grouped.enlisted.push(candidate);
          else if (type.includes("civilian")) grouped.civilians.push(candidate);
        }
      });

      return grouped;
    },

    getSelectedElecom() {
      const grouped = {
        civilians: [],
        others: [],
      };

      const candidates = this.$store.state.ga.candidates.elecom;
      const selected = this.$store.state.ga.selected_candidates.elecom;

      candidates.forEach((candidate) => {
        if (selected.includes(candidate.code)) {
          const type = candidate.type?.toLowerCase();

          if (type.includes("civilian")) grouped.civilians.push(candidate);
          else grouped.others.push(candidate);
        }
      });

      return grouped;
    },

    getSelectedAudit() {
      const grouped = [];

      const candidates = this.$store.state.ga.candidates.audit;
      const selected = this.$store.state.ga.selected_candidates.audit;

      candidates.forEach((candidate) => {
        if (selected.includes(candidate.code)) {
          grouped.push(candidate);
        }
      });

      return grouped;
    },
    getSelectedCount() {
      const category = this.getActiveCategory;
      const selected = this.$store.state.ga.selected_candidates[category];
      const candidates = this.$store.state.ga.candidates[category];

      const counts = {
        officers: 0,
        enlisted: 0,
        civilians: 0,
        total: selected.length,
      };

      if (category === "bod") {
        candidates.forEach((candidate) => {
          if (selected.includes(candidate.code)) {
            const type = candidate.type?.toLowerCase();
            if (type.includes("officer")) counts.officers++;
            else if (type.includes("enlisted")) counts.enlisted++;
            else if (type.includes("civilian")) counts.civilians++;
          }
        });
      } else if (category === "audit") {
        counts.total = selected.length;
      } else if (category === "elecom") {
        candidates.forEach((candidate) => {
          if (selected.includes(candidate.code)) {
            const type = candidate.type?.toLowerCase();
            if (type.includes("civilian")) counts.civilians++;
            else counts.officers++;
          }
        });
      }

      return counts;
    },

    getSelectedLimits() {
      const category = this.getActiveCategory;
      if (category === "bod") return { officers: 3, enlisted: 3, civilians: 2 };
      if (category === "audit") return { total: 2 };
      if (category === "elecom") return { total: 1, civilians: 1 };
      return {};
    },

    getTotalLimit() {
      const limits = this.getSelectedLimits;
      const category = this.getActiveCategory;

      if (category === "bod") {
        return (
          (limits.officers || 0) +
          (limits.enlisted || 0) +
          (limits.civilians || 0)
        );
      } else if (category === "audit") {
        return 2;
      } else if (category === "elecom") {
        return limits.total || 0;
      }
      return 0;
    },

    getTotalSelected() {
      const counts = this.getSelectedCount;
      const category = this.getActiveCategory;

      if (category === "bod") {
        return counts.officers + counts.enlisted + counts.civilians;
      } else if (category === "audit") {
        return counts.total;
      } else if (category === "elecom") {
        return counts.total;
      }
      return 0;
    },

    getProgressPercent() {
      const total = this.getTotalLimit;
      if (!total) return 0;
      return (this.getTotalSelected / total) * 100;
    },
  },
  methods: {
    getPlaceholder(event) {
      event.target.src = this.getImage("ga/", "papsi_placeholder.jpg");
    },
    startEditingCategory(category, source = "sidebar") {
      this.edit_return_category = this.getActiveCategory;
      this.$store.state.ga.active_category = category;

      this.show_limit = false;

      const counts = this.getSelectedCount;
      const limits = this.getSelectedLimits;

      let is_complete = false;
      if (category === "bod") {
        is_complete =
          counts.officers === limits.officers &&
          counts.enlisted === limits.enlisted &&
          counts.civilians === limits.civilians;
      } else if (category === "audit") {
        is_complete = counts.total === limits.total;
      } else if (category === "elecom") {
        is_complete = counts.total === limits.total;
      }

      this.is_editing = true;
      this.edit_source = source;

      if (source === "modal" && is_complete) {
        this.show_summary = false;
        this.show_confirm = false;
      } else {
        this.show_summary = false;
        this.show_confirm = false;
      }
    },

    finishEditing() {
      if (this.edit_return_category) {
        this.$store.state.ga.active_category = this.edit_return_category;
        this.edit_return_category = null;
      }
    },
    updateNotice(category) {
      const candidates = this.$store.state.ga.candidates[category] || [];

      if (!candidates.length) return;

      this.show_notice.bod = false;
      this.show_notice.elecom = false;
      this.show_notice.audit = false;

      const selected = this.$store.state.ga.selected_candidates[category];

      if (!selected || selected.length === 0) {
        this.show_notice[category] = true;
      }
    },

    handleBack() {
      const order = ["bod", "audit", "elecom"];
      const current = this.getActiveCategory;

      if (current === "bod") {
        this.$store.state.ga.selected_candidates.bod = [];
        this.$store.state.ga.selected_candidates.elecom = [];
        this.$store.state.ga.selected_candidates.audit = [];

        this.$store.state.ga.active_category = "bod";

        this.$router.push({ name: "dashboard-page" });
      } else {
        const prevIndex =
          (order.indexOf(current) - 1 + order.length) % order.length;
        this.$store.state.ga.active_category = order[prevIndex];
      }
    },

    closeNotice() {
      this.show_notice.bod = false;
      this.show_notice.audit = false;
      this.show_notice.elecom = false;
    },

    submitVotes() {
      // this.show_confirm = false;
      // this.$router.push("/ga/vote/ballot");

      this.$emit("showloader");

      const store = this.$store.state;
      const selected_candidates = store.ga.selected_candidates;
      const bod_candidates = store.ga.candidates.bod || [];
      const audit_candidates = store.ga.candidates.audit || [];
      const elecom_candidates = store.ga.candidates.elecom || [];

      const officer = bod_candidates.filter(
        (c) =>
          selected_candidates.bod?.includes(c.code) &&
          c.type?.toLowerCase().includes("officer"),
      );
      const enlisted = bod_candidates.filter(
        (c) =>
          selected_candidates.bod?.includes(c.code) &&
          c.type?.toLowerCase().includes("enlisted"),
      );
      const civilian = bod_candidates.filter(
        (c) =>
          selected_candidates.bod?.includes(c.code) &&
          c.type?.toLowerCase().includes("civilian"),
      );
      const audit = audit_candidates.filter((c) =>
        selected_candidates.audit?.includes(c.code),
      );
      const election = elecom_candidates.filter((c) =>
        selected_candidates.elecom?.includes(c.code),
      );

      const candidate_codes = [
        ...officer.map((c) => c.code),
        ...enlisted.map((c) => c.code),
        ...civilian.map((c) => c.code),
        ...audit.map((c) => c.code),
        ...election.map((c) => c.code),
      ];

      GA.vote(
        store.ga.code,
        store.ga.user.voter_key,
        store.ga.user.ballot_number,
        JSON.stringify(candidate_codes),
      )
        .then((response) => {
          store.ga.user.has_participated = true;
          store.ga.user.end_date = response.data.timestamp;
          // this.$router.push("/ga/vote/rating");
          this.$router.push("/ga/vote/ballot");

        })
        .catch((error) => {
          this.$emit("error", error);
        })
        .finally(() => {
          this.$emit("hideloader");
        });
    },

    handleProceed() {
      const order = ["bod", "audit", "elecom"];
      const current = this.getActiveCategory;

      if (this.is_editing) {
        if (this.edit_source === "modal") {
          this.is_editing = false;
          this.show_confirm = true;
          this.edit_return_category = null;
          this.edit_source = null;
          return;
        }
        this.is_editing = false;
        this.edit_return_category = null;
        this.edit_source = null;
      }

      if (current === "elecom") {
        this.show_confirm = true;
        return;
      }

      const next = order[(order.indexOf(current) + 1) % order.length];
      this.$store.state.ga.active_category = next;
    },
    toggleSelect(code) {
      const category = this.getActiveCategory;
      const selected = this.$store.state.ga.selected_candidates[category];
      const candidates = this.$store.state.ga.candidates[category];
      const candidate = candidates.find((c) => c.code === code);
      if (!candidate) return;

      const type = candidate.type?.toLowerCase();
      const counts = this.getSelectedCount;
      const index = selected.indexOf(code);

      if (index !== -1) {
        selected.splice(index, 1);
        return;
      }

      if (category === "bod") {
        if (type.includes("officer") && counts.officers >= 3)
          this.show_limit = "officers";
        else if (type.includes("enlisted") && counts.enlisted >= 3)
          this.show_limit = "enlisted";
        else if (type.includes("civilian") && counts.civilians >= 2)
          this.show_limit = "civilian";
        else selected.push(code);
      } else if (category === "audit") {
        if (selected.length >= 2) this.show_limit = true;
        else selected.push(code);
      } else if (category === "elecom") {
        if (selected.length >= 1) this.show_limit = true;
        else selected.push(code);
      }
    },

    isSelected(group, code) {
      return this.election.selected[group]?.has(code);
    },
    loadElection() {
      this.$emit("showloader");
      GA.getCurrentElection()
        .then((response) => {
          if (response.status === 200) {
            const { code, title, date } = response.data.data;

            this.$store.state.ga.code = code;
            this.election.code = code;
            this.$store.state.ga.title = title;
            this.election.title = title;
            this.$store.state.ga.date = date;
            this.election.date = date;
            this.loadCandidates();
            this.updateNotice(this.getActiveCategory);
          }
        })
        .catch((error) => {
          this.$emit("error", error);
        });
    },
    loadCandidates() {
      this.$emit("showloader");
      GA.getAllCandidates(this.election.code, this.$store.state.info.hash)
        .then((response) => {
          if (response.status === 200) {
            this.election.candidates.bod = response.data.data.bod;
            this.$store.state.ga.candidates.bod = response.data.data.bod;
            this.election.candidates.elecom = response.data.data.elecom;
            this.$store.state.ga.candidates.elecom = response.data.data.elecom;
            this.election.candidates.audit = response.data.data.audit;
            this.$store.state.ga.candidates.audit = response.data.data.audit;
          }
        })
        .catch((error) => {
          this.$emit("error", error);
        })
        .finally(() => this.$emit("hideloader"));
    },
    rotateCategory() {
      const order = ["bod", "audit", "elecom"];
      const current = this.$store.state.ga.active_category;
      const next = order[(order.indexOf(current) + 1) % order.length];

      this.$store.state.ga.active_category = next;
    },
  },
};
</script>

<style scoped>
.candidate-card {
  border: 2px solid transparent;
  border-radius: 12px;
  padding: 12px;
  cursor: pointer;
  transition: 0.2s;
  border-color: #d7dbdd;
}

.candidate-card.selected {
  border-color: v-bind(getTheme);
  background: #eaffe9;
}

.status-chips {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 0.5rem;
  margin-bottom: 1rem;
}

.chip {
  background-color: rgba(255, 255, 255, 0.2);
  color: white;
  padding: 0.25rem 0.75rem;
  font-size: 14px;
  font-weight: 500;
  border-radius: 9999px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.12), 0 2px 4px rgba(0, 0, 0, 0.08);
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.navigation {
  background-color: rgba(255, 255, 255, 0.2);
  color: white;
}

.bottom-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #f3f4f6;
  box-shadow: 0 -2px 6px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.bottom-inner {
  padding: 10px 16px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  gap: 12px;
  justify-content: space-between;
}

.votes-text {
  font-size: 11px;
  line-height: 1.1;
}

.votes-text .label {
  color: #6b7280;
}

.votes-text .count {
  color: v-bind(getTheme);
  font-weight: 700;
  font-size: 15px;
}

.progress-container {
  width: 100%;
  height: 6px;
  background: rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  background: v-bind(getTheme);
  transition: width 0.25s ease;
}

.check-icon {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 26px;
  height: 26px;
  border-radius: 999px;
}

.summary-sidebar {
  position: fixed;
  top: 0;
  right: 0;
  width: 320px;
  height: 100%;
  background: white;
  box-shadow: -4px 0 12px rgba(0, 0, 0, 0.12);
  z-index: 50;
  padding: 16px;
  overflow: visible;
}

.summary-header {
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 16px;
  text-align: center;
  color: #016b00;
}

.summary-group-header {
  background-color: #016b00;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  padding: 12px 12px;
}

.summary-group-header-elecom {
  background-color: #6485b8;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  padding: 12px 12px;
}

.summary-group-header-audit {
  background-color: #25387a;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  padding: 12px 12px;
}

.summary-group-body {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
  padding: 12px 12px;
  background-color: #f3f4f6;
  margin-bottom: 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.summary-group-title {
  font-weight: 700;
  color: white;
}

.summary-subtitle {
  font-size: 12px;
  color: white;
  margin-top: 4px;
}

.summary-item {
  background: white;
  border: 2px solid #e5e7eb;
  border-radius: 10px;
  padding: 10px;
  font-size: 13px;
  gap: 8px;
}

.summary-collapse-btn {
  position: absolute;
  left: -16px;
  top: 50%;
  transform: translateY(-50%);
  background-color: white;
  border-radius: 50%;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  z-index: 60;
}

.summary-collapse-btn img {
  display: block;
}

.summary-scroll {
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;

  -webkit-overflow-scrolling: touch;
  scroll-behavior: smooth;
}

.confirm-modal-body {
  max-height: 60vh;
  overflow-y: auto;
  padding: 4px;
}

.edit-btn {
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
